import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Action, ModalAction } from '../../models/action';
import { MainMenuService } from '../../services/mainmenu.service';
import { AuthService } from 'src/app/core/auth/auth.service';
import { AuthState } from 'src/app/core/auth/auth-state';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { GeneralService } from '../../services/general.service';
import { MatDialog } from '@angular/material/dialog';

declare var $: any;

@Component({
  selector: 'app-mainmenu', 
  templateUrl: './mainmenu.component.html',
  styleUrls: ['./mainmenu.component.scss']
})
export class MainMenuComponent implements OnInit, OnDestroy {

  @Input() type: string = '';

  actions: any = [];

  username: string = '';

  userData: any = {};

  actualUrl = '';

  loading = true;

  state: string = AuthState.SIGNED_OUT;

  companies: any = [];
  companiesSel: any = null;
  companiesSelData: any = null;

  avatarFile: any;

  mainSubscription: Subscription;
  routerSubscription: Subscription;
  protected companiesSubscription: Subscription;
  protected avatarSubscription: Subscription;
  protected userdataSubscription: Subscription;

  protected generalDataSubscription: Subscription;

  constructor(
    private mms: MainMenuService,
    private auth: AuthService,
    public router: Router,
    protected cdr : ChangeDetectorRef,
    protected gs: GeneralService,
    protected dialog: MatDialog
  ) {

    this.avatarSubscription = this.gs.avatar$.subscribe((result) => {
      this.avatarFile = result?.tiny || false;
    });
    this.generalDataSubscription = this.gs.generalData$.subscribe((result) => {
      this.companies = result?.companies || [];
      this.setCompaniesSelData();
    });

    this.companiesSubscription = this.gs.companiesSel$.subscribe((result) => {
      this.companiesSel = result;
      this.setCompaniesSelData();
    });

    this.mainSubscription = this.mms.mainmenu$.subscribe(actions => {
      this.actions = this.adjustArray(actions); 
    });

    this.userdataSubscription = this.gs.userdata$.subscribe(result => {
      this.userData = result;
    });

    this.routerSubscription = this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.actualUrl = event.url.substr(1);
        }

      });

  }

  ngOnInit() {
    this.loading = false;
  }

  ngOnDestroy() {
    this.mainSubscription.unsubscribe();
    this.routerSubscription.unsubscribe();
    this.avatarSubscription.unsubscribe();
    this.userdataSubscription.unsubscribe();
    this.companiesSubscription.unsubscribe();
    this.generalDataSubscription.unsubscribe();
  }

  adjustArray(array) {

    var nArray = [];
    for (var k in array) {
      if (array.hasOwnProperty(k)) {
        var item = array[k];
        if(item?.group){
          if (nArray[item.group] == undefined)
            nArray[item.group] = [];

          if (item.active)
            nArray[item.group].push(item);
        }
      }
    }

    return nArray;
  }

  goTo(action){
    this.gs.goTo(action);
  }

  onClick(param) {
    if (param instanceof ModalAction) {
      this.router.navigate(['openModal', param.component, ...(param.params?.id ? [param.params?.id] : [])]);
    } else if (param instanceof Action) {
      this.gs.setTitle(param.label);
      param.execute();
      $('body').removeClass('nav-active');
    } else if (param == 'nav') {
      $('body').toggleClass('nav-active');
    }
  }

  setCompaniesSelData() {
    this.companiesSelData = this.companies.filter(item => item?.company_person_id == this.companiesSel)[0] || {};

  }

}
